ManageIQ.angular.app.component('widgetSpinner', {
  template: `
    <div class="blank-slate-pf" style="padding: 10px">
      <div class="blank-slate-pf-icon">
        <i class="fa fa-spin fa-spinner"></i>
      </div>
    </div>
  `,
});
